import { create } from 'zustand';
import { getBatches, createBatch, deleteBatch, getBatchById } from '../services/batchService';

const useBatchStore = create((set, get) => ({
  batches: [],
  currentBatch: null,
  loading: false,
  error: null,
  _fetchedBatchId: null,

  fetchBatches: async (force = false) => {
    if (!force && get().batches.length > 0) return;
    set({ loading: true, error: null });
    try {
      const { data } = await getBatches();
      set({ batches: data.batches || [] });
    } catch (e) {
      set({ error: e?.response?.data?.message || e.message });
    } finally {
      set({ loading: false });
    }
  },

  fetchBatchById: async (id, force = false) => {
    if (!force && get()._fetchedBatchId === id && get().currentBatch) return;
    set({ loading: true, error: null });
    try {
      const { data } = await getBatchById(id);
      set({ currentBatch: data.batch, _fetchedBatchId: id });
      return data.batch;
    } catch (e) {
      set({ error: e?.response?.data?.message || e.message });
    } finally {
      set({ loading: false });
    }
  },

  addBatch: async (form) => {
    const { data } = await createBatch(form);
    set((s) => ({ batches: [...s.batches, data.batch] }));
    return data.batch;
  },

  removeBatch: async (id) => {
    await deleteBatch(id);
    set((s) => ({
      batches: s.batches.filter((b) => b._id !== id),
      currentBatch: s.currentBatch?._id === id ? null : s.currentBatch,
      _fetchedBatchId: s._fetchedBatchId === id ? null : s._fetchedBatchId,
    }));
  },
}));

export default useBatchStore;
